module.exports = __webpack_public_path__ + "static/media/solo39.855d7e08.JPG";